import React, { useMemo } from 'react';
import { Box, Button, Skeleton, Typography } from '@mui/material';
import { AppRow } from '../../layout/appRow';
import { AppToolbox } from '../app/appToolbox';
import { AppButtonContained } from '../app/button/appButtonContained';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Project } from '../../models/project';
import { generateProjectLabel } from '../../services/projectService';

const style = {
  appRow: {
    justifyContent: 'start',
  },
} as const;

interface TasksProps {
  onSwitch(): void;
  currentProject: Project | null;
  onOpen(): void;
  loadingTask: boolean;
}

export function TasksToolbox({
  onSwitch,
  currentProject,
  onOpen,
  loadingTask,
}: TasksProps): JSX.Element {
  const projectLabel = useMemo(
    () => generateProjectLabel(currentProject?.name, currentProject?.code),
    [currentProject?.name, currentProject?.code]
  );

  return (
    <AppToolbox
      pageTitle={'Tasks'}
      secondChildren={
        <AppButtonContained label={'Tasks'} handleClick={onOpen} isIconButton />
      }
      thirdChildren={
        <Box sx={{ flexDirection: 'column' }}>
          <AppRow sx={style.appRow}>
            <Button onClick={onSwitch}>
              <ArrowBackIcon fontSize={'large'} />
            </Button>
            {loadingTask ? (
              <Skeleton
                animation="wave"
                sx={{ height: '40px', width: '100px', ml: 3 }}
              />
            ) : (
              <Typography ml={3} variant="h4">
                {`${projectLabel}'s Tasks`}
              </Typography>
            )}
          </AppRow>
        </Box>
      }
    />
  );
}
